import { useEffect, useState } from "react";
import * as Yup from 'yup'
import { useListView } from "./header-details/core/ListViewProvider";
import { ID, isNotEmpty, KTCard, KTCardBody, QUERIES } from "../../../_dashboard/helpers";
import { useQuery } from "react-query";
import { getOneById } from "../../services/common_requests";
import { useFormik } from "formik";
import _ from 'lodash';
import ReactQuill from "react-quill";
import ImageEditModal from "../hotel-management/hotel-details/image-edit-modal/ImageEditModal";
import { images } from "../hotel-management/hotel-details/core/_models";
import { useIntl } from "react-intl";

const Header: React.FC = () => {
    const [selectedImage, setSelectedImage] = useState<images | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const intl = useIntl(); 
    const handleImageClick = (img: images) => {
        setSelectedImage(img);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };

    const handleUpdateImage = (updatedImage: { url: string; seoUrl?: string }) => {
        if (typeof formik.values.image === 'string') {
            formik.setFieldValue('image', updatedImage.url);
        }
        if (updatedImage.seoUrl) {
            formik.setFieldValue('seoUrl', updatedImage.seoUrl);
        }
        handleCloseModal();
    };

    const [uploadedImage, setUploadedImage] = useState<File | null>(null);

    const validationSchema = Yup.object().shape({

    })
    const { itemIdForUpdate, setItemIdForUpdate } = useListView()
    const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
    const {
        isLoading,
        data: Header,
        error,
    } = useQuery(
        `${QUERIES.HEADER_LIST}-Header-${itemIdForUpdate}`,
        () => {
            if (!itemIdForUpdate) {
                throw new Error("ID is undefined");
            }
            return getOneById(itemIdForUpdate, "/Header")
        },
        {
            cacheTime: 0,
            enabled: enabledQuery,
            onError: (err) => {
                setItemIdForUpdate(undefined)
                console.error(err)
            },
        }
    )
    const initialValues = Header ? {
        id: Header._id,
        description: Header.description,
        image: Header.image,
        email: Header.contact.email,
        phone: Header.contact.phone,
        adress: Header.contact.adress,
        seoUrl: Header.seourl,
        fbUrl:Header.fbUrl,
        instaUrl:Header.instaUrl,
        tiktokUrl:Header.tiktokUrl,
        youtubeUrl:Header.youtubeUrl,
    } : {
        id: '',
        description: 'L évasion parfaite, luxe et détente au cœur du paradis !...',
        image: 'https://xml.beachhotelsresorts.tn/file_manager/source/Iris Djerba Thalasso/AnyConv-com__HBG00173-HDR (1).webp',
        email: '',
        adress: '',
        seoUrl: "Header-alt"
    };

    const image = "https://xml.beachhotelsresorts.tn/file_manager/source/Iris Djerba Thalasso/AnyConv-com__HBG00173-HDR (1).webp"
    // Initialisation de Formik
    const formik = useFormik({
        initialValues,
        onSubmit: async (values) => {
            const modifiedFields = Object.keys(values).reduce((acc, key) => {
                const typedKey = key as keyof typeof values;
                if (!_.isEqual(values[typedKey], initialValues[typedKey])) {
                    acc[typedKey] = values[typedKey];
                }
                return acc;
            }, {} as Record<string, any>);
            const formData = new FormData();
            if (uploadedImage) {
                formData.append('image', uploadedImage);
            }
            Object.keys(modifiedFields).forEach((key) => {
                formData.append(key, modifiedFields[key]);
            });
            try {
                const response = await fetch('https://your-api-endpoint.com/upload', {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                await response.json();
            } catch (error) {
                console.error('Error:', error);
            }
        },
    });
    useEffect(() => {
        if (Header) {
            formik.setValues({
                id: Header._id,
                description: Header.description,
                image: Header.image,
                email: Header.contact.email,
                phone: Header.contact.phone,
                adress: Header.contact.adress,
                seoUrl: Header.seourl,
                fbUrl:Header.fbUrl,
                instaUrl:Header.instaUrl,
                tiktokUrl:Header.tiktokUrl,
                youtubeUrl:Header.youtubeUrl,

            });
        }
    }, [Header]);
    return (
        <>
            <KTCard>
                <KTCardBody className='py-4'>
                    <div className='py-4 app-content flex-column-fluid'>
                        <div className='row'>
                            <div className='col-md-12'>
                            <h3 className='mb-6'>{intl.formatMessage({ id: 'HEADER.TITLE' })}</h3>
                            <form onSubmit={formik.handleSubmit}>
                                    <div className='form-group  mb-4'>
                                    <label className='me-3 mb-3' >
                                    <strong>{intl.formatMessage({ id: 'HEADER.BACKGROUND_IMAGE' })}</strong>
                                    </label>
                                        <img
                                            src={image || Header?.image}
                                            alt={Header?.seourl}
                                            className='border-image image-container-dashed h-150px '
                                            onClick={() => handleImageClick({          
                                                _id: formik.values.id as unknown as ID,
                                               url: image || formik.values.image, seoUrl: formik.values.seoUrl })}
                                             style={{ cursor: 'pointer' }}
                                        />
                                        <div className='separator mb-4'></div>
                                        <label className='me-3 mb-3' >
                                        <strong>{intl.formatMessage({ id: 'HEADER.CONTACT_INFO' })}</strong>
                                        </label>
                                        
                                        <div className='form-group mb-4'>
                                            <div className='d-flex flex-wrap align-items-center'>
                                                <div className='col-12 col-md-auto mb-3 me-4'>
                                                    <label className='me-3 mb-3' >
                                                        <strong> {intl.formatMessage({ id: 'HEADER.EMAIL' })}</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100 w-md-auto'
                                                        name='email'
                                                        value={formik.values.email}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.email && formik.errors.email && (
                                                        <div className='text-danger'>{formik.errors.email as string}</div>
                                                    )}
                                                </div>
                                                <div className='col-12 col-md-auto mb-3 me-4'>
                                                    <label className='me-3 mb-3'>
                                                        <strong>  {intl.formatMessage({ id: 'HEADER.PHONE' })}</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100 w-md-auto'
                                                        name='phone'
                                                        value={formik.values.phone}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.phone && formik.errors.phone && (
                                                        <div className='text-danger'>{formik.errors.phone as string}</div>
                                                    )}
                                                </div>
                                                <div className='col-12 col-md-auto mb-3 me-4'>
                                                    <label className='me-3 mb-3'>
                                                        <strong>{intl.formatMessage({ id: 'HEADER.CITY' })}</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100 w-md-auto'
                                                        name='adress'
                                                        value={formik.values.adress}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.adress && formik.errors.adress && (
                                                        <div className='text-danger'>{formik.errors.adress as string}</div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                        <div className='separator mb-4'></div>
                                        <label className='me-3 mb-3' >
                                            <strong>{intl.formatMessage({ id: 'HEADER.SOCIAL_MEDIA' })}</strong>
                                        </label>
                                        <div className='form-group mb-4'>
                                            <div className='d-flex flex-wrap align-items-center'>
                                                <div className='col-12 col-md-auto mb-3 me-4'>
                                                    <label className='me-3 mb-3' >
                                                        <strong>{intl.formatMessage({ id: 'HEADER.FACEBOOK_URL' })}</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100 w-md-auto'
                                                        name='fbUrl'
                                                        value={formik.values.fbUrl}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.fbUrl && formik.errors.fbUrl && (
                                                        <div className='text-danger'>{formik.errors.fbUrl as string}</div>
                                                    )}
                                                </div>
                                                <div className='col-12 col-md-auto mb-3 me-4'>
                                                    <label className='me-3 mb-3'>
                                                        <strong>{intl.formatMessage({ id: 'HEADER.INSTAGRAM_URL' })}</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100 w-md-auto'
                                                        name='instaUrl'
                                                        value={formik.values.instaUrl}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.instaUrl && formik.errors.instaUrl && (
                                                        <div className='text-danger'>{formik.errors.instaUrl as string}</div>
                                                    )}
                                                </div>
                                                <div className='col-12 col-md-auto mb-3 me-4'>
                                                    <label className='me-3 mb-3'>
                                                        <strong>{intl.formatMessage({ id: 'HEADER.TIKTOK_URL' })}</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100 w-md-auto'
                                                        name='tiktokUrl'
                                                        value={formik.values.tiktokUrl}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.tiktokUrl && formik.errors.tiktokUrl && (
                                                        <div className='text-danger'>{formik.errors.tiktokUrl as string}</div>
                                                    )}
                                                </div>
                                                <div className='col-12 col-md-auto mb-3 me-4'>
                                                    <label className='me-3 mb-3'>
                                                        <strong>{intl.formatMessage({ id: 'HEADER.YOUTUBE_URL' })}</strong>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='form-control w-100 w-md-auto'
                                                        name='youtubeUrl'
                                                        value={formik.values.youtubeUrl}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.youtubeUrl && formik.errors.youtubeUrl && (
                                                        <div className='text-danger'>{formik.errors.youtubeUrl as string}</div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <ImageEditModal
                                        isOpen={isModalOpen}
                                        onClose={handleCloseModal}
                                        selectedImage={selectedImage || { url: '', seoUrl: '' }}
                                        onSave={handleUpdateImage}
                                    />
                                    <div className='separator mb-4'></div>


                                    <div className="modal-footer">
                                        <button type='submit' className='btn btn-primary me-2'>{intl.formatMessage({ id: 'HEADER.SAVE' })}</button>
                                        <button type="button" className="btn btn-secondary">{intl.formatMessage({ id: 'HEADER.RESET' })}</button>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </>
    )
}

export { Header }
